import React from 'react'
import Link from 'gatsby-link'
import leifNixonImg from '../../images/speakers/Leif-Nixon.jpg'

const interviewLN = () => (
<section id="interview" className="parallax-section">
	<div className="container">
        <br /><br /><br /><br /><br />
		<div className="row">
			<div className="col-md-12 col-sm-12 wow fadeInUp" data-wow-delay="0.1s">
				<div className="team-wrapper">
						<br /><br />
						<div className="row">
                            <div className="col-md-3">
								<img src={leifNixonImg} className="img-responsive" alt="Leif Nixon" />
                            </div>
                         <div className="col-md-9">
							<p>
								<h3>Leif Nixon: Be curious and delight in how much there is to learn and invent!</h3>
								<p>
                                Apart from being a tremendous learning experience and such a powerful motivation challenge, without any doubt, DevExperience also represents a huge opportunity to meet and discover great impacting personalities. Leif Nixon, for instance, is one of the speakers you definitely wish to see and learn from.
								<br />
								</p>
                            </p>
                           </div>
                        </div>
                        <div className="row">
							<div className="col-md-12">
								<p>
									<br /><br />
									<b>Are you ready to enjoy a mind blowing session on IT security at DevExperience?</b>
									<br /><br />
                                    It is common knowledge that personal examples inspire the best, so here is just a fast review of what you can expect when embarking upon a learning experience at DevExperience with Leif Nixon.
									<br /><br />
									<b>Quick personal review and professional background</b>
									<br /><br />
									Founder and owner of Nixon Security, with an extensive experience of over 10 years in IT security in Linux-centric environments, Leif Nixon is a remarkable individual you absolutely need to meet.<br />
                                    He regularly coordinates response to complex, multi-national incidents and has a wide network of contacts in industry, academia and law enforcement.<br />
                                    Since he is a regular contributor to industrial and academic IT security conferences, he is obviously strongly prepared to deliver valuable presentations on a wide range of subjects. <br />
                                    Let`s take a peak at just a few of his peculiar insights on IT security and related subjects.
									<br /><br />
									<b>Just a little bit more about personal context and professional becoming</b>
									<br /><br />
									As a child, I quite often dreamt about becoming an astronaut or pilot but, of course, that varied over time.
                                    <br /><br />
									<b>Your IT journey in a nutshell</b>
									<br /><br />
									My greatest surprise was how little it all has to do with computers. It’s mainly about people and communication, especially when it comes to security.
                                    <br /><br />
									<b>The major technological changes that marked your IT career</b>	
									<br /><br />
									Well, the arrival of home computers, GUI:s becoming commonplace, the Internet and the modern smartphone that have all changed how we interact with technology. But, nevertheless, how IT security has evolved from playing hide and seek on the net to becoming quite literally a matter of life and death.
									<br /><br />
									<b>Personal prediction of how IT will evolve in 2 years</b>
									<br /><br />
                                    I believe it will become even more deranged and incomprehensible. There is no single living person today who fully understands how a modern computer works and, in two years, they will have grown even more complex.
                                    <br /><br />
									<b>What do you expect from DevExperience`s attendees?</b>
									<br /><br />
                                    First and foremost, be curious, and delight in how much there is to learn and invent.
									<br /><br />
									<b>How does IT work mingle with your other passions?</b>
									<br /><br />
									I actually like to go to a small house in the middle of the forest, without any computers, chop wood and build a fire.
									<br /><br />
									<b>How do you use your technical skills in your day to day life?</b>
									<br /><br />
									Mostly, I break stuff. By habit, I port scan all networks I connect to. It’s astounding how much crap you can find on them.
                                    <br /><br />
                                    <i>DevExperience 2020 calls to meaningful involvement and practical action by implying Good Pressure for relevant positive impact. Thus, technology becomes part of the community while serving its wellbeing and sustainably contributing to the environment. 
                                    Consequently, refreshing your views on how to tackle and comprehend technology and its continuous development is, without saying, one elementary step in the process. Therefore, a blow your mind meeting with Leif Nixon seems like a proper start. Here is what you can expect!</i>
                                    <br /><br />
									<b>How does your company support and improve the local community and the environment?</b>
									<br /><br />
									I strive to make the community more safe and secure by working with local providers of critical infrastructure to improve their security posture. Also, I put criminals in prison.
                                    <br /><br />
									<b>What is, in your opinion, the main priority for technology to improve the welfare of a community?</b>
									<br /><br />
									There are many things that need to be done, like making the power grid and other critical infrastructure more secure and resilient, making money laundering and corruption harder, and stopping crime.
                                    <br /><br />
									<b>What are 3 key novelties and gaining insights you will share within your talk at DevExperience?</b>
									<br /><br />
									You should hopefully get at least a few good chuckles and, maybe, be provoked into thinking about why we are all so horribly bad at what we do.
                                    <br /><br />
									<b>What are the technological skills mandatory for those who want to attend your talk?</b>
									<br /><br />
									This is not a hard-core tech talk. Some basic familiarity with technology and computers should be enough.
                                    <br /><br />
									<b>What will atendees of DevExperience 2020 effectively and practically gain in their everyday work after attending your talk?</b>
									<br /><br />
									Hopefully they will be less preoccupied with whether or not they <b>could</b> and start thinking about if they <b>should</b>.
									<br /><br />
                                    <i>
                                    So, do you already feel you CAN do more, BE more and ACHIEVE more? Follow this line of thought and join the change movement at DevExperience 2020! It is the right place and the right time to do better together! Have you booked your seat already? Start now, jump in and begin! You matter! And so does your contribution!
                                    </i>
								</p>
							</div>
						</div>
				</div>
			</div>
        </div>
    </div>
</section>
)

export default interviewLN



// WEBPACK FOOTER //
// ./src/pages/blog/interview-leif-nixon.js